// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Wv9-N","content":"styles_content__1fCnA","checkbox":"styles_checkbox__fycEQ","checkboxLabel":"styles_checkboxLabel__1i_uQ"};